import { state, props } from 'cerebral/tags'
import { when, set, debounce, unset } from 'cerebral/operators'
import { setField } from '@cerebral/forms/operators'

export default [
  setField(state`${props`path`}`, props`value`),
  when(props`asyncFetch`),
  {
    true: [
      set(state`${props`path`}.loading`, true),
      debounce(100),
      {
        continue: [
          when(props`value`, value => value.length > 0),
          {
            true: [
              async function({ graphql, props }) {
                const data = await graphql.query(
                  `{resourcesSearch (resource: "${props.type}", criteria: "${props.value}")}`
                )
                return {
                  items: data.resourcesSearch
                }
              },
              function removeExistingResources({ state, props }) {
                const path = props.path.split('.')
                path.pop()
                const form = state.get(path.join('.'))
                const labels = Object.keys(form).reduce((acc, key) => {
                  if (key !== 'form') {
                    acc.push(form[key].label)
                  }
                  return acc
                }, [])
                return {
                  items: props.items.filter(item => {
                    return labels.indexOf(item) === -1
                  })
                }
              },
              set(state`${props`path`}.items`, props`items`),
              set(state`${props`path`}.isOpen`, true)
            ],
            false: [
              unset(state`${props`path`}.items`),
              set(state`${props`path`}.isOpen`, false)
            ]
          },
          set(state`${props`path`}.loading`, false)
        ],
        discard: []
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/changeFormValue.js